import script from "./itembasket.vue?vue&type=script&setup=true&lang=js"
export * from "./itembasket.vue?vue&type=script&setup=true&lang=js"

import "./itembasket.vue?vue&type=style&index=0&id=08abad96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08abad96"]])

export default __exports__